var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNatureConservation = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Ecology-Plant-Hand--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Ecology Plant Hand Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1 14.06h2s1 0 1 1v7s0 1 -1 1H1s-1 0 -1 -1v-7s0 -1 1 -1",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.85 18.27a3.23 3.23 0 0 0 -3.49 -1.13l-2 0.64a0.52 0.52 0 0 0 -0.35 0.49 2.27 2.27 0 0 1 -2.25 2.29H10.5a0.5 0.5 0 0 1 -0.5 -0.5 0.5 0.5 0 0 1 0.5 -0.5h5.25a1.25 1.25 0 1 0 0 -2.5h-3.69a4.92 4.92 0 0 1 -0.57 -0.38 6.82 6.82 0 0 0 -4 -1.62h-2a0.5 0.5 0 0 0 -0.5 0.5v5.9a0.51 0.51 0 0 0 0.34 0.47l1.92 0.66c2.63 0.91 4.09 1.41 5.42 1.41 1.63 0 3.05 -0.74 6.14 -2.39 1.28 -0.68 2.88 -1.53 4.91 -2.54a0.47 0.47 0 0 0 0.28 -0.37 0.46 0.46 0 0 0 -0.15 -0.43Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10.83a0.48 0.48 0 0 0 0.16 -0.63A23.56 23.56 0 0 0 7.5 6.06a0.5 0.5 0 0 1 0.09 -0.7 0.5 0.5 0 0 1 0.7 0.08c1.94 2.46 4 6.31 4.47 9.1a0.75 0.75 0 0 0 1.46 0.1c0.64 -2.07 2.18 -5 4.17 -6a0.5 0.5 0 1 1 0.44 0.9 6.73 6.73 0 0 0 -2.46 2.69 0.51 0.51 0 0 0 -0.05 0.4 0.54 0.54 0 0 0 0.28 0.31 2.11 2.11 0 0 0 0.83 0.17 3.44 3.44 0 0 0 2.39 -1.19 7.33 7.33 0 0 0 1 -6.72 0.54 0.54 0 0 0 -0.33 -0.28A0.48 0.48 0 0 0 20 5a6.42 6.42 0 0 1 -2.54 1.09 7 7 0 0 0 -2.24 0.91 2.72 2.72 0 0 0 -1.37 2.2 2.08 2.08 0 0 0 0.38 1.18 0.51 0.51 0 0 1 0 0.53c-0.11 0.21 -0.23 0.41 -0.33 0.61a0.27 0.27 0 0 1 -0.24 0.14 0.27 0.27 0 0 1 -0.22 -0.16 19.82 19.82 0 0 0 -1.1 -2.45 0.49 0.49 0 0 1 0.13 -0.62 2.93 2.93 0 0 0 1.07 -1.59 3.82 3.82 0 0 0 -1.14 -3.27 6.74 6.74 0 0 0 -3.48 -1.86A8.82 8.82 0 0 1 5.53 0.12a0.5 0.5 0 0 0 -0.77 0.15C3.38 2.87 4 7.62 5.54 9.4c2.51 2.96 4.34 1.5 4.46 1.43Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNatureConservation);
export default ForwardRef;